import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Input, DatePicker, Button, Select } from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import moment from 'moment';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import booleanConversion from 'shared/utils/booleanConversion';
import InsuranceContracts from './InsuranceContracts';

export default function SearchInsuranceContracts() {

    const dateFormat = 'D/M/YYYY';
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
   const defaultExportFilename = `report`
   const [exportFilename, setExportFilename] = useState(defaultExportFilename)
    const [endPoint, setEndPoint] = useState()
    const history = useHistory();
    const [form] = Form.useForm();
    const myRef = useRef();

    /* eslint-disable no-useless-escape */

    const formItemLayout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 12
        },
    };


    useEffect(() => {
        const channelPrefix = queryParams.get('channel') === '1' ? 'AN_' : 'IM_'
        form.setFieldsValue({
            'lastName': queryParams.get('lastName'),
            'firstName': queryParams.get('firstName'),
            'policyNumber': queryParams.get('policyNumber'),
            'plateNumber': queryParams.get('plateNumber'),
            'deviceImei': queryParams.get('deviceImei'),
            'isActive': queryParams.get('isActive'),
            'duration': queryParams.get('duration'),
            'startDate': queryParams.get('startDate') ? moment(queryParams.get('startDate'), dateFormat) : null,
            'startDateUntil': queryParams.get('startDateUntil') ? moment(queryParams.get('startDateUntil'), dateFormat) : null,
            'endDate': queryParams.get('endDate') ? moment(queryParams.get('endDate'), dateFormat) : null,
            'endDateUntil': queryParams.get('endDateUntil') ? moment(queryParams.get('endDateUntil'), dateFormat) : null,
            'dateCreated': queryParams.get('dateCreated') ? moment(queryParams.get('dateCreated'), dateFormat) : null,
            'dateCreatedUntil': queryParams.get('dateCreatedUntil') ? moment(queryParams.get('dateCreatedUntil'), dateFormat) : null,
            'channel':queryParams.get('channel') ? queryParams.get('channel'):'ALL'
        })
        setExportFilename(queryParams.get('channel') ? `${channelPrefix}${defaultExportFilename}` :defaultExportFilename)
        setEndPoint(`${EndPoints.CONTRACT.GETCONTRACT}?${queryParams.toString()}`);
    }, [queryParams, form])

    const isActiveContract = [
        { label: 'Όλα', value: null },
        { label: 'Ενεργά', value: 'true' },
        { label: 'Ακυρωμένα', value: 'false' },
    ]

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });

    const onFinish = (fieldsValues) => {
        const { duration, isActive } = fieldsValues;
        const values = {
            ...fieldsValues,
            'startDate': fieldsValues.startDate?.format(dateFormat),
            'startDateUntil': fieldsValues.startDateUntil?.format(dateFormat),
            'endDate': fieldsValues.endDate?.format(dateFormat),
            'endDateUntil': fieldsValues.endDateUntil?.format(dateFormat),
            'dateCreated': fieldsValues.dateCreated?.format(dateFormat),
            'dateCreatedUntil': fieldsValues.dateCreatedUntil?.format(dateFormat),
            'duration': duration ? parseInt(duration, 10) : null,
            'isActive': booleanConversion(isActive),
            'channel': fieldsValues.channel !== 'ALL' ? fieldsValues.channel: null
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.CONTRACT.GETCONTRACT}?${params}`);
        executeScroll();
    };

    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                >
                    <Row>
                        <Col span={12}  >
                            <Form.Item
                                label="Επώνυμο:"
                                name="lastName"
                                rules={[{ pattern: new RegExp(Validations.NAME.REGEX), message: Validations.NAME.MESSAGE }]}  >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="Όνομα:"
                                name="firstName"
                                rules={[{ pattern: new RegExp(Validations.NAME.REGEX), message: Validations.NAME.MESSAGE }]}  >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Συμβολαίου:"
                                name="policyNumber"
                                rules={[{ pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Κυκλοφορίας:"
                                name="plateNumber"
                                rules={[{ pattern: new RegExp(Validations.PLATENUMBER.REGEX), message: Validations.PLATENUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="startDate" label="Ημερομηνία Έναρξης Από:"  >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="startDateUntil" label="Ημερομηνία Έναρξης Έως:" >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="endDate" label="Ημερομηνία Λήξης Από:" >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="endDateUntil" label="Ημερομηνία Λήξης Έως:" >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="dateCreated" label="Ημερομηνία Καταχώρησης Από:" >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="dateCreatedUntil" label="Ημερομηνία Καταχώρησης Έως:" >
                                <DatePicker format={dateFormat} style={{ width: '70%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                normalize={value => value.toUpperCase()}
                                label="IMEI / MacAddress Συσκευής:"
                                name="deviceImei"
                                rules={[{ pattern: new RegExp(Validations.DEVICEIMEI.REGEX), message: Validations.DEVICEIMEI.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}  >
                            <Form.Item name="isActive" label="Κατάσταση Συμβολαίου:" >
                                <Select >
                                    {isActiveContract.map((isActive) => <Select.Option key={isActive.value} value={isActive.value}>{isActive.label}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="channel" label="Channel:" >
                                <Select defaultValue="ALL" options={[{value:'1', label:'Anytime'},{value:'2', label:'IM'},{value:'ALL', label:'ALL'}]} />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item>
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <InsuranceContracts endPoint={endPoint} exportFilename={exportFilename}/>
            </Col>
        </>
    );
}

/* eslint-disable no-useless-escape */